import { post } from '@/utils/request'

let cache = null

/**
 * @description 统计插件列表(按日期统计)
 */
export default function admin_product_plug_tongji_list() {
  if (cache) {
    return Promise.resolve(cache)
  }

  return post('admin_product_plug_tongji_list', {}).then((res) => {
    if (res.data.error_code === 0) {
      cache = res
    }
    return res
  })
}
